import React from 'react';

export const ProviderBadge: React.FC<{ provider: string | undefined }> = React.memo(({ provider }) => {
  if (provider === 'anthropic') {
    return (
      <span className="px-2 py-0.5 text-[11px] font-semibold rounded-full bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">
        Anthropic
      </span>
    );
  }
  if (provider === 'openai') {
    return (
      <span className="px-2 py-0.5 text-[11px] font-semibold rounded-full bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
        OpenAI
      </span>
    );
  }
  if (provider === 'mixed') {
    return (
      <span className="px-2 py-0.5 text-[11px] font-semibold rounded-full bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200">
        OpenAI + Anthropic
      </span>
    );
  }
  return null;
});
ProviderBadge.displayName = 'ProviderBadge';
